import { HttpService } from "@root/services/http";

export class AssessmentsUploadService extends HttpService {
  async uploadChunk(baseUrl: string, formData: FormData) {
    // Endpoint: /api/assessments/upload-chunk
    const url = `${baseUrl}/api/assessments/upload-chunk`;
    // Let browser set boundary for multipart form
    return this.post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      } as any,
    });
  }

  async deleteAssessment(baseUrl: string, id: string | number) {
    const url = `${baseUrl}/api/assessments/${id}`;
    return this.delete(url);
  }
}
